module.exports = __webpack_public_path__ + "img/ebcEnW.4d79d518.svg";